import { apiGet, apiPatch } from './client';
import type {
  BalanceType,
  BalanceTypeBatchRequest,
} from '../types/BalanceType';

export function getBalanceTypes(): Promise<BalanceType[]> {
  return apiGet<BalanceType[]>('/api/balance-types');
}

export function saveBalanceTypesBatch(
  added: BalanceType[],
  modified: BalanceType[],
  deletedIds: number[],
): Promise<BalanceType[]> {
  return apiPatch<BalanceTypeBatchRequest, BalanceType[]>(
    '/api/balance-types/batch',
    { added, modified, deleted: deletedIds },
  );
}
